import React from 'react';
import { motion } from 'framer-motion';

/**
 * LoadingResults Component
 * Displays skeleton loaders while searching
 */
const LoadingResults: React.FC = () => {
  return (
    <div className="absolute top-full left-0 right-0 mt-2 bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-300 dark:border-gray-700 overflow-hidden z-50 transition-colors duration-300">
      {[1, 2, 3].map((item) => (
        <motion.div
          key={item}
          className="px-6 py-4 border-b border-gray-50 dark:border-gray-700 last:border-b-0 transition-colors duration-300"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: item * 0.1 }}
        >
          <div className="flex items-center justify-between">
            <div className="flex-1 min-w-0 mr-3">
              <div
                className="h-5 bg-gray-200 dark:bg-gray-700 rounded-md mb-2 relative overflow-hidden transition-colors duration-300"
                style={{ width: `${150 + item * 30}px` }}
              >
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 dark:via-gray-600/40 to-transparent"
                  animate={{
                    x: ['-100%', '200%'],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "linear"
                  }}
                />
              </div>
              <div
                className="h-3 bg-gray-100 dark:bg-gray-600 rounded-md relative overflow-hidden transition-colors duration-300"
                style={{ width: `${100 + item * 20}px` }}
              >
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 dark:via-gray-500/40 to-transparent"
                  animate={{
                    x: ['-100%', '200%'],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "linear",
                    delay: 0.2
                  }}
                />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-7 w-12 bg-gray-200 dark:bg-gray-700 rounded-lg relative overflow-hidden transition-colors duration-300">
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 dark:via-gray-600/40 to-transparent"
                  animate={{
                    x: ['-100%', '200%'],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "linear",
                    delay: 0.3
                  }}
                />
              </div>
              <div className="h-7 w-16 bg-gray-100 dark:bg-gray-600 rounded-lg relative overflow-hidden transition-colors duration-300">
                <motion.div
                  className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 dark:via-gray-500/40 to-transparent"
                  animate={{
                    x: ['-100%', '200%'],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "linear",
                    delay: 0.4
                  }}
                />
              </div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default LoadingResults;
